"use strict";import{css as d}from"lit";const o=d`:host{--body-padding:40px;padding:var(--body-padding);padding-bottom:0}:host([noPadding]){--body-padding:0}`;export default o;
//# sourceMappingURL=modal-body.css.js.map
